import * as React from 'react';
import renderMathInElement from 'katex/dist/contrib/auto-render';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-python.js';
import 'prismjs/components/prism-r.js';
import { sanitizeUnsafeHTML, SanitizeConfigOptions } from 'elements/utils/sanitization';

interface Props {
    innerHtml: string;
    sanitizeConfig?: SanitizeConfigOptions;
    renderMathjax?: boolean;
}

export const RichText = ({ innerHtml, sanitizeConfig, renderMathjax = true }: Props) => {
    const inlineRef = React.useRef<HTMLDivElement>(null);
    const safeHtml = sanitizeUnsafeHTML(innerHtml, sanitizeConfig);

    const renderRichText = () => {
        const container = document.createElement('div');
        container.innerHTML = safeHtml;

        Prism.highlightAllUnder(container);

        /// We need to verify the function because in some test is undefined
        if (renderMathjax && renderMathInElement){
            renderMathInElement(
                container,
                {
                    delimiters: [
                        {left: '[mathjaxinline]', right: '[/mathjaxinline]', display: false},
                        {left: '[mathjax]', right: '[/mathjax]', display: true},
                        {left: '\\(', right: '\\)', display: false},
                        {left: '\\\\(', right: '\\\\)', display: false},
                        {left: '\\[', right: '\\]', display: true},
                        {left: '\\\\[', right: '\\\\]', display: true},
                    ]
                }
            );
        }

        return container.innerHTML;
      };


    return (
        <div dir='auto'
            ref={inlineRef}
            dangerouslySetInnerHTML={{
                __html: renderRichText(),
            }}
        />
    );
};
